import axios from "axios";
import {fetchAuthSession, signOut} from "aws-amplify/auth";

const dupeClient = axios.create({
    baseURL: (import.meta.env.VITE_REACT_APP_DUPE_BACKEND_ENDPOINT || process.env.REACT_APP_DUPE_BACKEND_ENDPOINT)
});

// See DupeBusinessClient: signing out here while leaving the request promise
// unsettled hangs every call made by a logged-out visitor.
dupeClient.interceptors.request.use(async function (config) {
    try {
        const session = await fetchAuthSession();
        const idToken = session?.tokens?.idToken;
        if (idToken) {
            config.headers.set('X-CLIENT-ID', idToken.toString());
        }
    } catch (error) {
        // No logged-in user: send the request unauthenticated.
    }
    return config;
});

dupeClient.interceptors.response.use(response => response, async error => {
    if (error.response?.status === 401) {
        try {
            const session = await fetchAuthSession();
            if (!session?.tokens?.idToken) await signOut();
        } catch (sessionError) {
            await signOut().catch(() => {});
        }
    }
    return Promise.reject(error);
});

// Helpful Debugging tools
// dupeClient.interceptors.request.use(request => {
//     console.log('Starting Request', JSON.stringify(request, null, 2))
//     return request
// })
//
// dupeClient.interceptors.response.use(response => {
//     console.log('Response:', JSON.stringify(response, null, 2))
//     return response
// })


export default dupeClient;